import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { ShieldCheck } from "@phosphor-icons/react";

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen vault-dark grid lg:grid-cols-2">
      <div className="relative hidden lg:block grain">
        <img src="https://images.unsplash.com/photo-1710981855156-1dd4b48e668d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Vault" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg,rgba(10,10,12,0.4),#0A0A0C)" }} />
        <div className="relative z-10 p-12 h-full flex flex-col justify-between">
          <Logo dark />
          <div>
            <ShieldCheck size={40} weight="fill" className="text-primary mb-5" />
            <h2 className="text-3xl font-bold tracking-tight max-w-sm leading-tight">Your important documents. Securely stored. Always accessible.</h2>
            <p className="mt-4 text-white/50 max-w-sm subhead text-xs">Store · Protect · Organize · Share · Verify</p>
          </div>
        </div>
      </div>
      <main id="main-content" tabIndex={-1} className="flex items-center justify-center p-6 sm:p-12 bg-[#0A0A0C] outline-none">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Logo dark /></div>
          <h1 className="text-2xl font-bold tracking-tight text-white">{title}</h1>
          {subtitle && <p className="mt-2 text-white/50 text-sm">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </main>
    </div>
  );
}

export { Link };
